import {
  HStack,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  VStack,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import Container from "../components/Container";
import Nav from "../components/nav/Nav";
import { Course } from "../const/types";
import ComponentSpinner from "../components/spinner/ComponentSpinner";
import cr from "../lib/request";
import { MagnifyingGlass } from "@phosphor-icons/react";
import Footer from "../components/Footer";
import NoData from "../components/feedback/NoData";
import TemaDropdown from "../components/TemaDropdown";
import useTemaMyCourses from "../globalState/useTemaMyCourses";
import MyCourseCard from "../components/card/MyCourseCard";

export default function MyCourses() {
  const [data, setData] = useState<Course[] | null>(null);
  const [search, setSearch] = useState<string>("");
  const ok = data?.filter(
    (course) =>
      course.nama_course.toLowerCase().includes(search.toLowerCase()) ||
      course.description.toLowerCase().includes(search.toLowerCase())
  );
  const [loading, setLoading] = useState<boolean>(false);
  const { myTema } = useTemaMyCourses();

  const getCourse = useCallback(() => {
    setLoading(true);
    const url = `api/usercourse/mycourse`;
    const payload = {
      limit: null,
      offset: null,
      tema: myTema?.id,
    };
    cr.post(url, payload)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [myTema?.id]);

  useEffect(() => {
    getCourse();
  }, [getCourse, myTema]);

  return (
    <VStack align={"stretch"} gap={0} minH={"100vh"}>
      <Nav />

      <Container mx={"auto"} py={12} minH={"calc(100vh - 72px)"}>
        <Heading fontSize={28} mx={"auto"} textAlign={"center"} mb={8}>
          Course Saya
        </Heading>

        <HStack mb={8} mx={"auto"}>
          <InputGroup>
            <InputLeftElement>
              <Icon as={MagnifyingGlass} />
            </InputLeftElement>
            <Input
              w={"100%"}
              maxW={"500px"}
              placeholder="Cari course"
              _placeholder={{ opacity: 0.8 }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>

          <TemaDropdown />
        </HStack>

        <SimpleGrid mt={4}>
          {!loading && data ? (
            ok && ok?.length > 0 ? (
              <SimpleGrid columns={[1, 2, 3, 4]} gap={4} spacingY={8}>
                {ok.map((course, i) => {
                  return <MyCourseCard key={i} data={course} />;
                })}
              </SimpleGrid>
            ) : (
              <NoData />
            )
          ) : (
            <ComponentSpinner />
          )}
        </SimpleGrid>
      </Container>

      <Footer />
    </VStack>
  );
}
